import React from 'react';

const ArquivosIco = () => {
  return (
    <svg width="100%" height="100%" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 396.7 490">
      <path class="st0" d="M303.3,16.5v65.2c0,6.4,5.2,11.7,11.7,11.7c0,0,0,0,0,0h65.2L303.3,16.5z" />
      <path class="st0" d="M393.2,120.1c-2.2-2.2-5.1-3.4-8.2-3.4h-70c-19.3,0-35-15.7-35-35v-70C280,5.2,274.8,0,268.3,0H35
	C15.7,0,0,15.7,0,35v420c0,19.3,15.7,35,35,35h326.7c19.3,0,35-15.7,35-35V128.3C396.7,125.2,395.4,122.3,393.2,120.1z M259.5,304.2
	l-50.9,50.9c-0.1,0.1-0.3,0.1-0.4,0.3c-5.3,5.1-13.6,5.1-18.9,0c-0.1-0.1-0.3-0.2-0.4-0.3l-50.9-50.9c-5.3-5.6-5-14.5,0.6-19.8
	c5.4-5.1,13.8-5.1,19.2,0l27.1,27V184.8c0-7.7,6.3-14,14-14s14,6.3,14,14v126.6l27.1-27c6-4.9,14.8-3.9,19.7,2.1
	C263.7,291.7,263.7,299.1,259.5,304.2L259.5,304.2z"/>
    </svg>

  )
}

export default ArquivosIco;